import { registerTldrawLibraryVersion } from "@tldraw/utils";
export * from "@tldraw/sync-core";
import { useSync } from "./useSync.mjs";
import { useSyncDemo } from "./useSyncDemo.mjs";
registerTldrawLibraryVersion(
  "@tldraw/sync",
  "3.7.2",
  "esm"
);
export {
  useSync,
  useSyncDemo
};
//# sourceMappingURL=index.mjs.map
